module.exports = __webpack_public_path__ + "static/media/icon_customerexpert.d1717390.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/customerexpert/icon_customerexpert.png
// module id = 1639
// module chunks = 0